/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable react/prop-types */
/* eslint-disable compat/compat */
import React, { useEffect, useState } from 'react';
import { useLocation } from '@reach/router';
import { graphql, useStaticQuery } from 'gatsby';
import { NewGLULayout } from '../../layouts/new-glu-layout';
import NewGluCard from '../../components/glu/organisms/new-home-glu-cards';
import { PBSLink } from '../../components/atoms/link';
import GLUExitPopUp from '../../components/molecules/glu-exit-pop-up';

const fetcher = (query) =>
	fetch(`https://graphql.datocms.com/`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			'Accept': 'application/json',
			'Authorization': `Bearer ${process.env.GATSBY_DATOAPIKEY}`,
		},
		body: JSON.stringify({ query }),
	})
		.then((res) => {
			if (!res.ok)
				throw new Error(`Error ${res.status}: ${res.statusText}`);
			return res.json();
		})
		.then((data) => data.data);

const SEARCH_QUERY = (search) => `
  query MySearchBar {
    allGluCourses(
    first: ${search ? 100 : 0}
      orderBy: _createdAt_DESC
      skip: 0
      locale: en
      filter: {
        OR: [
          { title: { matches: { pattern: "${search}", caseSensitive: false } } },
          { intro: { matches: { pattern: "${search}", caseSensitive: false } } }
        ],
        AND: {
          hideInOnDemandLibrary: { eq: "null" },
          hideInOnDemandLibrary: { eq: "false" },
          slug: { neq: null }
        }
      }
    ) {
      id
      title
      slug
      intro
      thumbnail {
        url
      }
      category {
        title
        slug
      }
        moreCategory {
        title
        slug
      }	
      timeToWatchInMinutes
    }
  }
`;

const groupByCategory = (results) =>
	results.reduce((acc, course) => {
		const categoryTitle =
			course.category?.title ||
			course.moreCategory?.title ||
			'Uncategorized';
		if (!acc[categoryTitle]) {
			acc[categoryTitle] = [];
		}
		acc[categoryTitle].push(course);
		return acc;
	}, {});

const SearchResults = ({ locale }) => {
	const location = useLocation();
	const [results, setResults] = useState([]);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);
	const [totalSearchCount, setTotalSearchCount] = useState(0);

	const query = new URLSearchParams(location.search).get('query');
	const data = useStaticQuery(graphql`
		query {
			datoCmsGluSiteSetting(locale: { eq: "en" }) {
				primaryHeader {
					title
					link
					icon {
						url
						alt
					}
					treeChildren {
						title
						subText
						link
						icon {
							url
							alt
						}
						position
						locale
					}
				}
				upcomingWebinar {
					title
					dateAndTime(formatString: "Do MMMM YYYY")
					startTime: dateAndTime
					slug
					timeEnd
				}
			}
			allDatoCmsBlogPage(
				limit: 5
				sort: { order: DESC, fields: meta___createdAt }
				filter: { locale: { eq: "en" } }
			) {
				nodes {
					title
					slug
					categories {
						slug
					}
				}
			}
		}
	`);

	useEffect(() => {
		if (query) {
			setLoading(true);
			fetcher(SEARCH_QUERY(query))
				// eslint-disable-next-line no-shadow
				.then((data) => {
					const courses = data.allGluCourses || [];
					setResults(courses);
					setTotalSearchCount(courses.length);
					setLoading(false);
				})
				.catch((err) => {
					setError(err.message);
					setLoading(false);
				});
		}
	}, [query]);

	const groupedResults = groupByCategory(results);

	return (
		<NewGLULayout
			nav={data.datoCmsGluSiteSetting.primaryHeader}
			weeklyWebinar={data.datoCmsGluSiteSetting.upcomingWebinar}
			articleData={data.allDatoCmsBlogPage.nodes}
		>
			<GLUExitPopUp locale={locale} />
			<div className="p-5 ">
				{!query ? (
					<div>
						<p className="text-2xl text-center ">
							No search results
						</p>
						<p className="text-lg mb-20 text-center ">
							No results matched this search. Please use the
							search box to find courses.
						</p>
					</div>
				) : (
					<>
						{query && (
							<h1 className="text-2xl text-center font-bold mb-4">
								Total &quot;{totalSearchCount}&quot; Search
								Results for - &quot;
								{query}&quot;
							</h1>
						)}
						{loading && <p>Loading...</p>}
						{error && (
							<p className="text-red-500">Error: {error}</p>
						)}
						{Object.keys(groupedResults).length > 0
							? Object.entries(groupedResults).map(
									([categoryTitle, courses]) => (
										<div
											key={categoryTitle}
											className="mb-5"
										>
											<h2 className="text-xl font-bold mb-4">
												{categoryTitle} (
												{courses.length}{' '}
												{courses.length === 1
													? 'Result'
													: 'Results'}
												)
											</h2>
											<div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-10">
												{courses.map((course) => {
													const link = `/elearning/${
														course.category?.slug ||
														course.moreCategory
															?.slug
													}/${course.slug}`;
													return (
														<PBSLink
															variant="Link"
															to={link}
															key={`${
																course.id
															}-${
																course.title
															}${Math.random()}`}
															className="w-full !no-underline !text-black"
														>
															<div className="grid h-full w-full">
																<NewGluCard
																	key={
																		course.id
																	}
																	data={
																		course
																	}
																	compact={
																		false
																	}
																/>
															</div>
														</PBSLink>
													);
												})}
											</div>
										</div>
									)
							  )
							: !loading && (
									<p className="text-center mb-10">
										No results matched this search. Try
										editing your search or look for
										something else.
									</p>
							  )}
					</>
				)}
			</div>
		</NewGLULayout>
	);
};

export default SearchResults;
